/// <amd-module name="Search/Package/Flux/Stores/SearchStore" />

import * as Utils from "Search/Package/Utils";
import * as BaseSearchStore from "Search/Shared/Base/Stores/SearchStore2";
import { PackageSearchRequest, PackageSearchResponseContent, PackageResult } from "Search/WebApi/Contracts/Search.Shared";
import { IResultsLoadedPayload } from "Search/Shared/Base/ActionsHub2";

export class SearchStore extends BaseSearchStore.SearchStore<PackageSearchRequest, PackageSearchResponseContent, PackageResult> {

    protected areCorrectResultsLoaded(
        request: PackageSearchRequest,
        payload: IResultsLoadedPayload<PackageSearchRequest, PackageSearchResponseContent, PackageResult>): boolean {
        request.$top = payload.request.$top;
        return Utils.areQueriesSame(request, payload.request);
    }

    public areQueriesSame = (request: PackageSearchRequest, payload: PackageSearchRequest): boolean => {
        return Utils.areQueriesSame(request, payload);
    }
}